/* eslint-disable array-callback-return */
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import { cloneDeep, concat, get, set } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import MUIAccordionComponent from 'src/components/ui-component/mui-accordion/MUIAccordionComponent';
import MUIAlert from 'src/components/ui-component/mui-alert/MUIAlert';
import { useApplication } from 'src/context/ApplicationContext';
import DeleteRecord from 'src/lib/api/DeleteRecord';
import GetRecords from 'src/lib/api/GetRecords';
import { APIS } from 'src/lib/constants/apis';
import {
	ALS_ERLEDIGT_MARKIEREN_LABEL,
	ERLAUTERUNG_IN_KOSTEN_TITLE,
	KOSTEN_ARTEN,
	KOSTEN_POSITION,
	PARTNER_DATEN_NICHT_ERFASST,
} from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue, GetGesamtAusgabeGEGesamtEinnahme, NonRequired } from 'src/lib/validation/ValidationTypes';
import { checkIfSpecificKostenPositionHasComment } from 'src/pages/private/online-antrag/application-helper-function/PruefAssistenzHelperFunktion';
import { withKostenkategorieEinsatzbereichFilter } from 'src/utils/einsatzbereichHelper';
import { getFormStrucWithoutComponentTable } from 'src/utils/formStruc';
import { addIndexesToPath, checkReadOnlyInUeberarbeitung, getOptionsFromRes, removeDataKeys, removeNullDeep } from 'src/utils/helper';
import PruefAssistenz from '../../../../../antrag-components/PruefAssistenz';
import {
	checkIfPruefAssitenzNeedsToValidate,
	getBasisDataKostenKategorie,
	getKostenErlauterung,
	getSelectedKostenKategorieBezeichnung,
} from '../../../../../application-helper-function/AppHelperfunctions';
import EinnahmenHinweisGlobal from '../../../../global-structure/einnahmen-hinweis/content/EinnahmenHinweisGlobal';
import { transformDataSkizze } from '../../../../global-structure/finanzierung-plan-skizze/content/FinanzierungPlanSkizzeGlobal';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import KostenpositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
const P = Schema.attributes;
const KP_P = KostenpositionSchema.attributes;

const EigenmittelSkizzeLoewe: FC<{
	kostentraeger: string;
	unternehmenId?: number;
	institutionsTyp?: string;
	hasComment?: boolean;
	selectedOrgaName?: string;
}> = ({ kostentraeger, unternehmenId, institutionsTyp, hasComment, selectedOrgaName }) => {
	const { application, setApplicationProperty, readOnly, saveApplication } = useApplication();
	const [kostenKategorie, setKostenKategorie] = useState([]);
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	const handleAddEigenmittel = async () => {
		let appCopy = cloneDeep(application);

		const data = getBasisDataKostenKategorie(
			appCopy,
			kostenKategorie, // All kostenkategorie for Eigenmittel, to find default Kostenkategorie id
			kostentraeger,
			unternehmenId,
			KOSTEN_POSITION.Einnahme,
			KOSTEN_ARTEN.Eigenmittel,
		);
		set(
			appCopy,
			addIndexesToPath(
				P.Foerderantrag_Kostenpositions.path,
				[`${get(appCopy, P.Foerderantrag_Kostenpositions.path, []).length}`],
				['Foerderantrag_Kostenpositions'],
			),
			{ attributes: data },
		);
		saveApplication(false, appCopy);
	};
	const handleDeleteEigenmittel = async (id: number) => {
		try {
			let appcopy = cloneDeep(application);
			const allKostenposition = get(appcopy, P.Foerderantrag_Kostenpositions.path, []);
			set(
				appcopy,
				P.Foerderantrag_Kostenpositions.path,
				allKostenposition.filter((item: any) => item.id !== id),
			);
			let res = await DeleteRecord(APIS.Kostenposition, id);
			if (res) {
				saveApplication(false, appcopy);
			}
		} catch (err: any) {
			console.error('ERROR: Deleting Personalkosten', err);
		}
	};

	useEffect(() => {
		const fetch = async () => {
			try {
				const filter = withKostenkategorieEinsatzbereichFilter(
					{
						Allgemein_Kostenposition: KOSTEN_POSITION.Einnahme,
						Allgemein_Kostenart_Finanzierung: KOSTEN_ARTEN.Eigenmittel,
						Allgemein_Antragsformular: { $contains: get(application, P.Allgemein_Antragsformular.path) },
						Allgemein_Aktiv: { $eq: true },
					},
					APIS.Antrag,
				);
				let res = await GetRecords(APIS.Kostenkategorie, [], filter);
				setKostenKategorie(removeNullDeep(removeDataKeys(get(res, 'data'))));
			} catch (err: any) {
				console.error('ERROR: Fetching Kostenkategories ', err);
			}
		};
		fetch();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<EinnahmenHinweisGlobal
				kostentraeger={kostentraeger}
				unternehmenId={unternehmenId}
				institutionsTyp={institutionsTyp}
				selectedOrgaName={selectedOrgaName}
			/>
			{get(application, P.Foerderantrag_Kostenpositions.path, []).map((ele: any, i: number) => {
				if (
					get(ele, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Einnahme &&
					get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Eigenmittel &&
					get(ele, `${KP_P.Unternehmen.path}.id`) === unternehmenId
				) {
					const selectedKostenKategorieName = getSelectedKostenKategorieBezeichnung(
						kostenKategorie,
						get(ele, KP_P.Allgemein_Kostenkategorie.path),
					);
					return (
						<MUIAccordionComponent
							key={i}
							summaryTitle={`Eigen- und Drittmittel  ${selectedKostenKategorieName ? '| ' + selectedKostenKategorieName : ''}`}
							onDelete={() => handleDeleteEigenmittel(get(ele, 'id'))}
							showDeleteButton={!updatedReadOnly}
							hasComment={checkIfSpecificKostenPositionHasComment(readOnly, ele)}
						>
							<PruefAssistenz
								statusPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Pruefstatus.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								hinweisPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Hinweis_Fuer_Antragsteller.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								ueberarbeitetAmPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Ueberarbeitet_Am.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								erledigtPath={addIndexesToPath(
									P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Erledigt.path,
									[`${i}`],
									['Foerderantrag_Kostenpositions'],
								)}
								formStruc={mapFormStruc(PruefAssistenzStruc(), i)}
							/>

							<MUIAlert
								title={ERLAUTERUNG_IN_KOSTEN_TITLE}
								message={getKostenErlauterung(kostenKategorie, get(ele, KP_P.Allgemein_Kostenkategorie.path))}
							/>
							<CreateForm
								formStruc={mapFormStruc(formStrucEigenmittel(0, 0, kostenKategorie), i)}
								formValues={application}
								updateFormValuesFunc={setApplicationProperty}
								readOnly={updatedReadOnly}
								api={APIS.Kostenposition}
								size='small'
							/>
						</MUIAccordionComponent>
					);
				}
			})}
			{unternehmenId ?
				<Button sx={{ mt: '2rem', maxWidth: 'fit-content' }} endIcon={<AddIcon />} onClick={handleAddEigenmittel} disabled={updatedReadOnly}>
					Eigen- und Drittmittel hinzufügen
				</Button>
			:	<MUIAlert message={PARTNER_DATEN_NICHT_ERFASST} />}
		</>
	);
};

export default EigenmittelSkizzeLoewe;

const PruefAssistenzStruc = () => {
	return [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
};
const formStrucEigenmittel = (gesamtEinnahme: number, gesamtAusgabe: number, kostenKategorie?: any): FormStrucItem[] => {
	const kostenKategories = kostenKategorie || [];
	return [
		{
			fields: [
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kostenkategorie,
					type: 'enumeration',
					label: 'Kategorie',
					options: getOptionsFromRes(kostenKategories, 'Allgemein_Bezeichnung'),
				},
				{
					...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme,
					format: 'currency',
					validation: [{ validateFunction: GetGesamtAusgabeGEGesamtEinnahme, params: [gesamtEinnahme, gesamtAusgabe] }],
				},
			],
		},
		{
			fields: [{ ...P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Bezeichnung, validation: [{ validateFunction: NonRequired }] }],
		},
	];
};
const mapFormStruc = (formStruc: any[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				let pathWithoutIndex = get(value, 'path', '') as string;
				return {
					...value,
					path:
						pathWithoutIndex.slice(0, P.Foerderantrag_Kostenpositions.path.length) +
						`.${index}` +
						pathWithoutIndex.slice(P.Foerderantrag_Kostenpositions.path.length),
				};
			}),
		};
	});
	return result;
};

export const getFormStrucEigenmittelSkizzeLoewe = (application: any, unternehmenId: number) => {
	let result: FormStrucItem[] = [];
	get(application, P.Foerderantrag_Kostenpositions.path, []).map((ele: any, i: number) => {
		if (
			get(ele, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Einnahme &&
			get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Eigenmittel &&
			get(ele, `${KP_P.Unternehmen.path}.id`) === unternehmenId
		) {
			const allKostenPosition = get(application, P.Foerderantrag_Kostenpositions.path);
			const { groupedData } = transformDataSkizze(allKostenPosition);
			const gesamtEinnahme = groupedData[unternehmenId]?.gesamtEinnahme;
			const gesamtAusgabe = groupedData[unternehmenId]?.gesamtAusgabe;
			const formStrucWithoutCT = getFormStrucWithoutComponentTable(
				formStrucEigenmittel(gesamtEinnahme ? gesamtEinnahme : 0, gesamtAusgabe ? gesamtAusgabe : 0),
			);

			const formStrucWithIndex = mapFormStruc(formStrucWithoutCT, i);

			const isHinweisFieldRequired = checkIfPruefAssitenzNeedsToValidate(ele, KP_P.Pruefung_Pruefstatus.path, KP_P.Pruefung_Erledigt.path);
			if (isHinweisFieldRequired) {
				result = concat(result, formStrucWithIndex, mapFormStruc(PruefAssistenzStruc(), i));
			} else {
				result = concat(result, formStrucWithIndex);
			}
		}
	});

	return result;
};
